import React from 'react'

import { ProductsListItem } from './ProductsListItem'
import * as S from './styled'
import type { ProductsListProps } from './types'

export const ProductsList = ({ size = 'small', children }: ProductsListProps) => (
  <S.Container size={size}>
    <tbody>
      {React.Children.map(
        children,
        (child) => child && React.cloneElement(child as React.ReactElement, { size }),
      )}
    </tbody>
  </S.Container>
)

ProductsList.Item = ProductsListItem
